export const stockImages = [
  {
    venue: "cityline",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643203408/stock%20images/CityLine-123_ymiqnw.jpg",
  },
  {
    venue: "frisco",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643203523/stock%20images/Boho_Frisco_10.16-1_aygegv.jpg",
  },
  {
    venue: "tupps",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643203587/stock%20images/PG2_9000_y8dian.jpg",
  },
  {
    venue: "edgemere",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643203661/stock%20images/Boho-11-30-21-33_hcmmhc.jpg",
  },
  {
    venue: "warren",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643203719/stock%20images/IMG_0700_a1sjdm.jpg",
  },
  {
    venue: "saltbox",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643203813/stock%20images/PGP_6025-2_bkulpi.jpg",
  },
  {
    venue: "west",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643203875/stock%20images/WestEndBoho12.4.21-2_s56322.jpg",
  },
  {
    venue: "mile",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643204028/stock%20images/BOHO-10-15-21-3_vf1a0i.jpg",
  },
  {
    venue: "garden",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643204163/stock%20images/Boho1-20_brakl5.jpg",
  },
  {
    venue: "ventana",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643204580/stock%20images/DSC044461_jyxevb.jpg",
  },
  //   {
  //     venue: "feel good",
  //   },
  //   {
  //     venue: "downtown",
  //   },
  {
    // venue: "hill",
  },
  {
    venue: "omni",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643204667/stock%20images/DSC029801_eotbtn.jpg",
  },
  {
    // venue: "observer",
  },
  //   { venue: "brewing" },
  {
    venue: "sugar",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643204764/stock%20images/01_rjdu3d.jpg",
  },
  {
    venue: "music",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643204832/stock%20images/DSC042191_red5am.jpg",
  },
  {
    venue: "victory",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643204912/stock%20images/VictoryPark-33_iql929.jpg",
  },
  //   { venue: "symposium" },
  {
    venue: "ikea",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643204968/stock%20images/PGP_5975_kofunr.jpg",
  },
  //   { venue: "wedding" },
  {
    venue: "windsong",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643205045/stock%20images/bhwr-7_a2wdfh.jpg",
  },
  {
    venue: "sound",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643205121/stock%20images/PGP_2092_bzy2ep.jpg",
  },
  {
    venue: "cotton",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643205237/stock%20images/DSC_2042_frheut.jpg",
  },
  {
    venue: "morning",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643205294/stock%20images/091221_MorningAfter_ASHGPHOTO_002859_udkgip.jpg",
  },
  {
    venue: "twelve",
    stockImage:
      "https://res.cloudinary.com/dkceblkn7/image/upload/v1643205357/stock%20images/Boho-12DaysofChristmas-21-43_do9he4.jpg",
  },
];
